export const checkInTypeOptions = [
  /*
  { value: 'SALES_MEETING', label: 'Sales Meeting' },
  { value: 'SALES_ATTEMPT', label: 'Sales Attempt' }, 
  { value: 'PHONE_CALL', label: 'Phone Call' },
  { value: 'VIDEO_CONFERENCE', label: 'Video Conference' },
  { value: 'COLD_CALL', label: 'Cold Call' },
  { value: 'EMAIL', label: 'Email' },
  { value: 'INTERNAL_INEFFICIENCY', label: 'Internal Inefficiency' },
   */
  { value: 'Sales Meeting', label: 'Sales Meeting' },
  { value: 'Sales Attempt', label: 'Sales Attempt' }, 
  { value: 'Phone Call', label: 'Phone Call' },  
  /*REMOVED BECAUSE OPTION IS DEPRECATED { value: 'Video Conference', label: 'Video Conference' }, */
  /*REMOVED BECAUSE OPTION IS DEPRECATED { value: 'Cold Call', label: 'Cold Call' },  */
  { value: 'Email', label: 'Email' },
  /*REMOVED BECAUSE OPTION IS DEPRECATED { value: 'Internal Inefficiency', label: 'Internal Inefficiency' }, */
]